import {NgModule} from "@angular/core";
import {CommonModule, DatePipe} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {AngularFileUploaderModule} from "angular-file-uploader";
import {WjCoreModule} from "@grapecity/wijmo.angular2.core";
import {WjInputModule} from "@grapecity/wijmo.angular2.input";
import {WjGridModule} from "@grapecity/wijmo.angular2.grid";
import {WjGridFilterModule} from "@grapecity/wijmo.angular2.grid.filter";
import {WjChartModule} from "@grapecity/wijmo.angular2.chart";
import {WjNavModule} from "@grapecity/wijmo.angular2.nav";
import {WjOlapModule} from "@grapecity/wijmo.angular2.olap";
import {WjGridMultirowModule} from "@grapecity/wijmo.angular2.grid.multirow";
import {TooltipModule} from "ngx-bootstrap/tooltip";
import {CustomDatePipe} from "app/services/custom.date.pipe";
import {SortPipe} from "app/services/sort.pipe";
import {FilterPipe} from "app/services/filter.pipe";
import {SecurePipe} from "app/services/secure.pipe";
import {SpinnerComponent} from "main/ui/spinner/spinner.component";

@NgModule({
    imports: [
        AngularFileUploaderModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TooltipModule,
        WjCoreModule,
        WjInputModule,
        WjGridModule,
        WjGridFilterModule,
        WjChartModule,
        WjNavModule,
        WjOlapModule,
        WjGridMultirowModule,
    ],
    declarations: [CustomDatePipe, FilterPipe, SecurePipe, SortPipe, SpinnerComponent],
    providers: [CustomDatePipe, DatePipe, FilterPipe, SecurePipe, SortPipe],
    exports: [
        AngularFileUploaderModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TooltipModule,
        WjCoreModule,
        WjInputModule,
        WjGridModule,
        WjGridFilterModule,
        WjChartModule,
        WjNavModule,
        WjOlapModule,
        WjGridMultirowModule,
        CustomDatePipe,
        FilterPipe,
        SecurePipe,
        SortPipe,
        SpinnerComponent
    ]
})
export class SharedModule {
}
